import { render, staticRenderFns } from "./SmsPopup.vue?vue&type=template&id=02108792&"
import script from "./SmsPopup.vue?vue&type=script&lang=js&"
export * from "./SmsPopup.vue?vue&type=script&lang=js&"
import style0 from "./SmsPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports